import { createContext, ReactNode, use } from 'react'

const AstraPrivacyModeContext = createContext<boolean>(false)

/** Tailwind classes that blur sensitive free-text content and reveal it on hover. */
export const ASTRA_PRIVACY_BLUR_REVEAL_CLASS = 'blur-[5px] transition-[filter] duration-0 hover:blur-none hover:duration-[3s]'

type AstraPrivacyModeProviderProps = {
    children: ReactNode
    value: boolean
}

/**
 * Provides the current privacy-mode state to Astra input components.
 *
 * When privacy mode is on, text-like inputs render as `type="password"` and
 * textareas are visually obscured, so personal data the user types is hidden.
 */
export const AstraPrivacyModeProvider = ({ children, value }: AstraPrivacyModeProviderProps) => (
    <AstraPrivacyModeContext value={value}>{children}</AstraPrivacyModeContext>
)

/** Returns whether privacy mode is active. Defaults to `false` when no provider is present. */
export const useAstraPrivacyMode = () => use(AstraPrivacyModeContext)
